import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8b91598e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { class: "base-form" }
const _hoisted_5 = { style: {"display":"inline-block","margin-right":"1rem"} }
const _hoisted_6 = { style: {"display":"inline-block"} }
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"right","line-height":"1rem","margin-top":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Opportunity = _resolveComponent("Opportunity")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isCreatingViewMode)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Новый сервисный компонент "))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, " Карточка сервисного компонента "))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                class: "base-form",
                model: _ctx.ruleForm,
                ref: "jobForm",
                "status-icon": "",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Компонент (узел)",
                    "label-position": "top",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Группа компонента",
                    "label-position": "top",
                    prop: "componentGroup"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        auth: "",
                        ref: "jobComponentGroupPicker",
                        modelValue: _ctx.ruleForm.componentGroup,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.componentGroup) = $event)),
                        placeholder: "Поиск по названию группы",
                        "search-url": "/api/servicejobcomponentgroups",
                        "catalog-tab": _ctx.tabs.jobComponentGroups,
                        onCatalogItemPicked: _ctx.onComponentGroupPicked
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ruleForm.componentGroup?.name), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Сервисная операция по-умолчанию",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        auth: "",
                        ref: "jobComponentDefaultOperationPicker",
                        modelValue: _ctx.ruleForm.defaultOperation,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.defaultOperation) = $event)),
                        placeholder: "Поиск по названию операции",
                        "search-url": "/api/servicejoboperations/search",
                        "catalog-tab": _ctx.tabs.jobOperations,
                        onCatalogItemPicked: _ctx.onComponentDefaultOperationPicked
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ruleForm.defaultOperation?.name), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Описание компонента (узла)",
                    "label-position": "top",
                    prop: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.description,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
                        maxlength: "255",
                        "show-word-limit": "",
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.asyncOperationPending,
                                  onClick: _ctx.onFormSubmitClick
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.isCreatingViewMode ? 'Создать компонент' : 'Сохранить'), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_el_button, { onClick: _ctx.onFormCancelClick }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Отменить ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 10 }, {
                            default: _withCtx(() => [
                              (!_ctx.isCreatingViewMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      disabled: _ctx.asyncOperationPending,
                                      onClick: _ctx.onFormDeleteClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Удалить компонент ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 10 }, {
                            default: _withCtx(() => [
                              _createTextVNode("   ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              (!_ctx.isCreatingViewMode && !_ctx.isDeletionAllowed)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_component_el_text, {
                                      type: "info",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Opportunity)
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" Компонент нельзя удалить - на него ссылаются сервисные работы (ссылок " + _toDisplayString(_ctx.referencedJobsCount) + ") ", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}